import * as DLOverlayQuizz from '../DL/OverlayQuizz';

const GetQuestions = async () => {
    try {
        const response = await DLOverlayQuizz.GetQuestions();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error inesperado al intentar cargar las preguntas.' };
    }
};

const SubmitQuiz = async (name, email, phone, selectedOptionIds, acceptedTerms, feedback = null) => {
    try {
        const payload = {
            name,
            email,
            phone,
            selectedOptionIds,
            acceptedTerms,
            feedback
        };
        const response = await DLOverlayQuizz.SubmitQuiz(payload);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error inesperado al enviar tus respuestas.' };
    }
};

const GetSettings = async () => {
    try {
        const response = await DLOverlayQuizz.GetSettings();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cargar la configuración del overlay.' };
    }
};

const GetAdminParticipants = async () => {
    try {
        const response = await DLOverlayQuizz.GetAdminParticipants();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cargar el ranking.' };
    }
};

const ToggleVisibility = async (id) => {
    try {
        const response = await DLOverlayQuizz.ToggleVisibility(id);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al actualizar el estado del registro.' };
    }
};

const SelectWinner = async (id) => {
    try {
        const response = await DLOverlayQuizz.SelectWinner(id);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al establecer el ganador.' };
    }
};

const UpdatePosition = async (offset) => {
    try {
        const response = await DLOverlayQuizz.UpdatePosition(offset);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar desplazar la pantalla.' };
    }
};

const UpdateBannerMode = async (mode) => {
    try {
        const response = await DLOverlayQuizz.UpdateBannerMode(mode);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar la configuración del banner.' };
    }
};

const UpdateOverlayVisibility = async (visible) => {
    try {
        const response = await DLOverlayQuizz.UpdateOverlayVisibility(visible);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar la visibilidad del overlay.' };
    }
};

const ToggleActiveTrivia = async (active) => {
    try {
        const response = await DLOverlayQuizz.ToggleActiveTrivia(active);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar cambiar el estado de la trivia.' };
    }
};

const TrackMetric = async (eventName, sessionId, source) => {
    try {
        const response = await DLOverlayQuizz.TrackMetric(eventName, sessionId, source);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar guardar la métrica.' };
    }
};

const GetAdminStats = async () => {
    try {
        const response = await DLOverlayQuizz.GetAdminStats();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar obtener las estadísticas.' };
    }
};

const CheckDuplicateParticipant = async (email, phone) => {
    try {
        const response = await DLOverlayQuizz.CheckDuplicateParticipant(email, phone);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al verificar duplicidad del registro.' };
    }
};

const ResetQuizzData = async () => {
    try {
        const response = await DLOverlayQuizz.ResetQuizzData();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar reiniciar la dinámica.' };
    }
};

export {
    GetQuestions,
    SubmitQuiz,
    GetSettings,
    GetAdminParticipants,
    ToggleVisibility,
    SelectWinner,
    UpdatePosition,
    UpdateBannerMode,
    UpdateOverlayVisibility,
    ToggleActiveTrivia,
    TrackMetric,
    GetAdminStats,
    CheckDuplicateParticipant,
    ResetQuizzData
};
